/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import {enquireScreen} from 'enquire-js';
import Nav0 from './Nav0';
import Banner1 from './Banner1';
import Content5 from './Content5';
import Teams1 from './Teams1';
import Content13 from './Content13';
import Banner3 from './Banner3';
import Footer1 from './Footer1';
import {
    Nav00DataSource,
    Banner10DataSource,
    Content51DataSource,
    Teams10DataSource,
    Content130DataSource,
    Banner31DataSource,
    Footer10DataSource,
} from './data.source';
import './less/antMotionStyle.less';
import NewsImgCon from "../components/NewsImgCon";
import CarouselCon from "../components/CarouselCon";
import {NewsDetailDataSource} from "../common/globalDataList";
import {BackTop} from 'antd';
import {getWXMessage} from '../common/axios';

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const {location} = window;

export default class Home extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            isMobile,
            show: !location.port, // 如果不是 dva 2.0 请删除
            newsList: [],
        };
    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({isMobile: !!b});
        });
        // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
        /* 如果不是 dva 2.0 请删除 start */
        if (location.port) {
            // 样式 build 时间在 200-300ms 之间;
            setTimeout(() => {
                this.setState({
                    show: true,
                });
            }, 500);
        }
        /* 如果不是 dva 2.0 请删除 end */
    }

    componentWillMount() {
        this.getWXMessage()
    }

    getWXMessage() {
        window.newsList = []
        console.log("res")

        try {
            getWXMessage().then(res => {
                console.log("res", res)
                window.newsList = []

                let list = res.data.data ? res.data.data : []
                if (list && list.length > 0) {
                    list.map(item => {
                        window.newsList.push({
                            title: item.title,
                            feTitle: item.fetitle,
                            imgList: [{title: "", url: item.imgurl}],
                            type: 'wechat',
                            url: item.url,
                            textList: [
                                item.tip,
                            ],
                        },)
                    })
                }
                NewsDetailDataSource.map((i, index) => {
                    if (index > 0) {
                        newsList.push(i)
                    }
                })
                this.setState({newsList: newsList});
            }).catch((e)=>{
                this.setState({newsList: NewsDetailDataSource});
            })
        } catch (e) {
            console.log(e);
            this.setState({newsList: NewsDetailDataSource});
        }
    }


    render() {

        sessionStorage.newDetailIx = 0;
        //
        let IndustryList = [
            {
                img: "img/coreBusiness1.png", icon: "img/icon1.png", text:
                    "大气污染防治“一市一策"
            },
            {
                img: "img/coreBusiness2.png", icon: "img/icon2.png", text:
                    "大气环境网格化监管与重污染天气应对"
            },
            {
                img: "img/coreBusiness3.png", icon: "img/icon4.png", text:
                    "大气污染源耦合解析与达标规划"
            },
            {
                img: "img/coreBusiness4.png", icon: "img/icon3.png", text:
                    " 地表及地下水环境分析与模拟"
            },
        ];

        const children = [
            <Nav0
                id="Nav0_0"
                key="Nav0_0"
                dataSource={Nav00DataSource}
                isMobile={this.state.isMobile}

            />,
            <Banner1
                id="Banner1_0"
                key="Banner1_0"
                dataSource={Banner10DataSource}
                isMobile={this.state.isMobile}
            />,
            <div style={{background: 'rgb(248,248,248)',}} id={"News_Center"}>
                <div className={"container"} style={{minHeight: '65vh', backgroundColor: "#f3f4f6"}}>
                    <CarouselCon title={"新闻资讯 / News Center"} list={this.state.newsList}
                    />
                </div>
            </div>,
            <div className={"container"} style={{minHeight: '56vh',}} id={"Core_Business"}>
                <NewsImgCon title={"核心业务 / Core Business"} list={IndustryList} showBottom={true}
                            showMore={(key) => window.location.href = '/#/productsAndServices?key=' + key}
                />

                {/*
                 <Content5
                id="Content5_1"
                key="Content5_1"
                dataSource={Content51DataSource}
                isMobile={this.state.isMobile}
            />,
                <Teams1
                id="Teams1_0"
                key="Teams1_0"
                dataSource={Teams10DataSource}
                isMobile={this.state.isMobile}
            />,*/}
            </div>,
            <Content13
                id="Content13_0"
                key="Content13_0"
                dataSource={Content130DataSource}
                isMobile={this.state.isMobile}

            />,

            <Banner3
                id="Banner3_1"
                key="Banner3_1"
                dataSource={Banner31DataSource}
                isMobile={this.state.isMobile}
            />,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
            <BackTop/>
        ];
        return (
            <div
                className="templates-wrapper"
                ref={(d) => {
                    this.dom = d;
                }}
            >

                {/* 如果不是 dva 2.0 替换成 {children} start */}
                {this.state.show && children}
                {/* 如果不是 dva 2.0 替换成 {children} end */}
            </div>
        );
    }
}


